export default "__VITE_ASSET__DS6C9lBj__"